import * as ls from '../../utils/localStorage';

const lsState = ls.get('settings.auth') ? ls.get('settings.auth') : false;
const defaultState = lsState;

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case 'SET_AUTH':
      state = action.payload;

      ls.set('settings.auth');
      return state;
    case 'RESET_AUTH':
      state = false;

      ls.del('settings.auth');

      return state;
    default:
      return state;
  }
}
